import React, { useState, useEffect } from "react";
//import topImage from './img/download.jpeg';
import logo from "./img/Logo (1).png";
import { useNavigate } from "react-router-dom";
import { Config } from "../.env.js";
import axios from "axios";

const AllCamp = ({ campaign = "Hello", alignLeft }) => {
    const { id, campaignName } = campaign;
    const [product, setProduct] = useState([]);
    const [hasRefundForm, setHasRefundForm] = useState(false);
    const navigate = useNavigate();
    console.log(product);
    const topImageUrl = campaign.brandLogo
        ? `${Config.API_URL}/${campaign.brandLogo}`
        : "/fallback.jpg"; // fallback if no brand logo exists
    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axios.get(`${Config.API_URL}/api/product`, {
                    params: { campaignId: id },   // ✅ match backend query param
                });
                console.log("product", response.data);
                setProduct(Array.isArray(response.data) ? response.data : []);
            } catch (error) {
                console.error("Error fetching product:", error);
            }
        };

        if (id) {
            fetchProduct();
        }
    }, [id]);



    useEffect(() => {
        const fetchRefundFormStatus = async () => {
            try {
                const res = await axios.get(
                    `${Config.API_URL}/api/check-refund-template`,
                    {
                        params: { campaignName },
                    }
                );
                setHasRefundForm(res.data.exists);
            } catch (err) {
                console.error("Error checking refund form:", err);
            }
        };

        if (campaignName) {
            fetchRefundFormStatus();
        }
    }, [campaignName]);

    const topImageStyle = {
        backgroundImage: `url(${topImageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "170px",
        width: "450px",
        borderRadius: "6px",
        marginBottom: "-10px",
        marginLeft: "-15px",
        marginTop: "-13px",
        position: "relative",
    };

    const logoStyle = {
        position: "absolute",
        bottom: "100px",
        left: "5px",
        width: "40px",
        height: "36px",
        top: "130px",
    };

    const handleApply = () => {
        navigate(
            `/admin-viewdetails/${campaignName}?campaignDetails=${campaignName}`
        );
    };

    const handleApplyDeliverables = () => {
        navigate(`/admin-orderform/${campaignName}?campaignName=${campaignName}`);
    };

    const handleConfirmation = () => {
        navigate(`/admin-refundform/${campaignName}?campaignName=${campaignName}`);
    };

    const handleOrders = () => {
        navigate(`/order-table`, { state: { campaignName } });
    };

    const handleCopyCampaign = () => {
        navigate("/campaignForm", {
            state: {
                campaign,
                product,
                hasRefundForm,
            },
        });
    };

    return (
        <div className="is-max-desktop">
            <div>
                <div className="card-content">
                    <div className="box mt-6 ml-5" style={{ width: 465 }}>
                        <div className="box" style={topImageStyle}>
                            <img src={logo} alt="Logo" style={logoStyle} />
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <h1>{campaignName}</h1>
                            <div className="dropdown is-right is-hoverable">


                            </div>
                        </div>

                        <p className="has-text-weight-bold" style={{ marginTop: "10px" }}>
                            Total Items For Review :{" "}
                            <span style={{ color: "#3273dc" }}>{product?.length || 0}</span>
                        </p>
                        {product.length > 0 && product[0].maxItemsPerUser && (
                            <p className="has-text-weight-bold" style={{ marginTop: "6px" }}>
                                Items a User Can Review :{" "}
                                <span style={{ color: "#23d160" }}>
                                    {product[0].maxItemsPerUser}
                                </span>
                            </p>
                        )}

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "20px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                }}
                            >
                                <p className="has-text-grey-light">Campaign Name</p>
                                <p className="has-text-weight-bold">{campaignName}</p>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-end",
                                }}
                            >
                                <p className="has-text-grey-light">Item Name</p>
                                {product?.slice(0, 10).map((item, index) => (
                                    <p key={index} className="has-text-weight-bold">
                                        {item.productName}
                                    </p>
                                ))}
                            </div>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "20px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                }}
                            >
                                <p className="has-text-grey-light">Available Slots</p>
                                {product?.slice(0, 10).map((item, index) => (
                                    <p key={index} className="has-text-weight-bold">
                                        {item.productSlot}
                                    </p>
                                ))}
                            </div>
                        </div>

                        <div style={{ flexDirection: "row", gap: "10px" }}>
                            <button
                                onClick={handleApply}
                                className="button is-small-custom mt-3 ml-1 has-text-info"
                                style={{ width: "200px", height: "30px" }}
                            >
                                View Campaign
                            </button>
                            <button
                                onClick={handleApplyDeliverables}
                                className="button is-small-custom mt-3 ml-1 has-text-info"
                                style={{ width: "200px", height: "30px" }}
                            >
                                View Order Form
                            </button>
                            {hasRefundForm && (
                                <button
                                    onClick={handleConfirmation}
                                    className="button is-small-custom mt-2 ml-1 has-text-info"
                                    style={{ width: "200px", height: "30px" }}
                                >
                                    View Refund Form
                                </button>
                            )}
                            <button
                                onClick={handleOrders}
                                className="button is-small-custom mt-2 ml-1 has-text-info"
                                style={{ width: "200px", height: "30px" }}
                            >
                                View Orders
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllCamp;